"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VIDEO_SOURCES;
(function (VIDEO_SOURCES) {
    VIDEO_SOURCES["COMPUTER"] = "computer";
    VIDEO_SOURCES["DROPBOX"] = "dropbox";
    VIDEO_SOURCES["GOOGLE_DRIVE"] = "drive";
    VIDEO_SOURCES["YOUTUBE"] = "youtube";
    VIDEO_SOURCES["VIMEO"] = "vimeo";
    VIDEO_SOURCES["FACEBOOK"] = "facebook";
    VIDEO_SOURCES["MIXED"] = "mixed";
    VIDEO_SOURCES["LIVE"] = "live";
})(VIDEO_SOURCES = exports.VIDEO_SOURCES || (exports.VIDEO_SOURCES = {}));
exports.EXTERNAL_VIDEO_SOURCES = [
    VIDEO_SOURCES.YOUTUBE,
    VIDEO_SOURCES.VIMEO,
    VIDEO_SOURCES.FACEBOOK,
];
//# sourceMappingURL=video-sources.js.map